import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { CompanyVehicleSetup } from 'contracts/CompanyVehicleSetups';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_COMPANY_VEHICLE_SETUP_',
  }
);

export interface FetchCompanyVehicleSetupState {
  data: CompanyVehicleSetup | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchCompanyVehicleSetupRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: CompanyVehicleSetup;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchCompanyVehicleSetupState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchCompanyVehicleSetupState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: FetchCompanyVehicleSetupState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (
  state: FetchCompanyVehicleSetupState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchCompanyVehicleSetupState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchCompanyVehicleSetup = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchCompanyVehicleSetupTypes = Types;
export const FetchCompanyVehicleSetupActions = Creators;
